import actions from "@/store/auth/actions";
import mutations from "@/store/auth/mutations";
import state from "@/store/auth/state";

export default {
    actions,
    mutations,
    state
}